import { Check, Rocket, Target, BarChart, Users } from "lucide-react";

export const DemoBenefits = () => {
  return (
    <div className="space-y-8">
      <div className="space-y-6">
        <h2 className="text-2xl font-semibold text-gray-900">
          What You'll Get in Your Free Demo
        </h2>
        
        <div className="space-y-4">
          {[
            {
              icon: <Target className="w-5 h-5 text-blue-600" />,
              title: "Personalized Strategy Review",
              description: "Get expert insights tailored to your business goals and challenges."
            },
            {
              icon: <BarChart className="w-5 h-5 text-blue-600" />,
              title: "Growth Opportunity Analysis",
              description: "Discover untapped potential and areas for improvement in your current approach."
            },
            {
              icon: <Rocket className="w-5 h-5 text-blue-600" />,
              title: "Action Plan",
              description: "Receive a clear roadmap of next steps to achieve your business objectives."
            },
            {
              icon: <Users className="w-5 h-5 text-blue-600" />,
              title: "Expert Consultation",
              description: "Connect with our specialists who understand your industry challenges."
            }
          ].map((benefit, index) => (
            <div key={index} className="flex gap-4 p-4 rounded-lg bg-gray-50">
              <div className="shrink-0 bg-white p-2 rounded-full shadow-sm">
                {benefit.icon}
              </div>
              <div>
                <h3 className="font-medium text-gray-900">{benefit.title}</h3>
                <p className="text-gray-600 text-sm">{benefit.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="bg-blue-50 p-6 rounded-lg">
        <h3 className="text-lg font-medium text-blue-900 mb-2">
          Why Schedule a Demo?
        </h3>
        <ul className="space-y-2">
          {[
            "No commitment required - it's completely free",
            "Get actionable insights in just 30 minutes",
            "See real examples of success in your industry",
            "Ask questions and get expert answers"
          ].map((point, index) => (
            <li key={index} className="flex items-center gap-2 text-blue-800">
              <Check className="w-4 h-4 text-blue-600" />
              <span className="text-sm">{point}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};